import React, { useState } from 'react';
import { FaHome, FaPlay, FaImage, FaHeart, FaUser, FaLock, FaGlobe, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './style/EventDetails.css';
import './style/Guides.css';
import { Helmet } from 'react-helmet-async';
import { Breadcrumbs } from '@aws-amplify/ui-react';
import { MdChevronRight } from 'react-icons/md';
import BeOnWallProfile from '../assets/img/guides/beonwall_profile.png';
import BeOnWallcreateeventqrcode from '../assets/img/guides/createevent-qrcode.png';
import BeOnWallcreateevent from '../assets/img/guides/create-event.png';
import BeOnWallDownloaddeleteimages from '../assets/img/guides/Download-delete-images.png';
import BeOnWallSettings from '../assets/img/guides/Settings.png';
import BeOnWallStart from '../assets/img/guides/Start.png';
import BeOnWalluploadmessagepicture from '../assets/img/guides/upload_message_picture.png';
import { useTranslation, Trans } from 'react-i18next';


function GuideContent({ activeTab }) {
  const { t } = useTranslation();
  return (
    <>
    <Helmet>
      <title>BeOnWall – Guide d’utilisation</title>
      <meta name="description" content="Apprenez à utiliser BeOnWall : créer un événement, afficher un diaporama, gérer les médias, et plus encore." />
      <meta name="keywords" content="guide, tutoriel, aide, utilisation, BeOnWall, créer événement, diaporama, QR code" />
      <meta property="og:title" content="BeOnWall – Guide d’utilisation" />
      <meta property="og:description" content="Toutes les étapes pour bien utiliser BeOnWall, expliquées simplement." />
      <meta property="og:url" content="https://beonwall.com/guides" />
      <meta property="og:image" content="https://beonwall.com/assets/logobeonwall.png" />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
    
    <div className="event-content-wrapper">
      <div className="event-tab-content">
        {activeTab === 'Event' && (
          <div className="event-info guide-info">
            <h3>{t('guides.title.event')}</h3>
            <p>{t('guides.event.title')}</p>
            <ul style={{ textAlign: 'left' }}>
              <li><a href="#create-event">{t('guides.event.lienhypertitle.createvent')}</a></li>
              <li><a href="#choose-type">{t('guides.event.lienhypertitle.choosetype')}</a></li>
              <li><a href="#share-link">{t('guides.event.lienhypertitle.sharelink')}</a></li>
              <li><a href="#upload-content">{t('guides.event.lienhypertitle.uploadcontent')}</a></li>
              <li><a href="#view-contributions">{t('guides.event.lienhypertitle.viewcontribution')}</a></li>
            </ul>

            <div>
              <h4 id="create-event">{t('guides.event.lienhypertitle.createvent')}</h4>
              <p><Trans i18nKey="guides.event.text.createvent" components={{ bold: <span className="bold-gold" />, br: <br /> }} />
              </p>
              <img src={BeOnWallcreateevent} alt="Créer un événement" className="guide-img" />
            </div>

            <div>
              <h4 id="choose-type">{t('guides.event.lienhypertitle.choosetype')}</h4>
              <p><Trans i18nKey="guides.event.text.choosetype.Photo" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p>
              <p><Trans i18nKey="guides.event.text.choosetype.Livephoto" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p>
              <p><Trans i18nKey="guides.event.text.choosetype.LiveText" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p>
              <p><Trans i18nKey="guides.event.text.choosetype.LivePhoto&Text" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p>
            </div>

            <div>
              <h4 id="share-link">{t('guides.event.lienhypertitle.sharelink')}</h4>
               <p><Trans i18nKey="guides.event.text.ShareQrCode" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p>
              <img src={BeOnWallcreateeventqrcode} alt="Partage de l'evenement qrcode" className="guide-img" />
            </div>

            <div>
              <h4 id="upload-content">{t('guides.event.lienhypertitle.uploadcontent')}</h4>
              <p><Trans i18nKey="guides.event.text.Participationinstant" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p>
              <img src={BeOnWalluploadmessagepicture} alt="Sharing Image & message" className="guide-img" />
            </div>

            <div>
              <h4 id="view-contributions">{t('guides.event.lienhypertitle.viewcontribution')}</h4>
              <p><Trans i18nKey="guides.event.text.DownloadP" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p>
              <img src={BeOnWallDownloaddeleteimages} alt="Telechargement image & message et suppression" className="guide-img" />
            </div>
          </div>
        )}


       {activeTab === 'diaporama' && (
        <div className="event-info guide-info">
          <h3>{t('guides.title.Diaporama')}</h3>
          <p>{t('guides.diaporama.title')}</p>
          <ul style={{ textAlign: 'left' }}>
            <li><a href="#start-diapo">{t('guides.diaporama.lienhypertitle.start')}</a></li>
            <li><a href="#font-style">{t('guides.diaporama.lienhypertitle.font')}</a></li>
            <li><a href="#colors">{t('guides.diaporama.lienhypertitle.colors')}</a></li>
            <li><a href="#background-image">{t('guides.diaporama.lienhypertitle.background')}</a></li>
            <li><a href="#banner">{t('guides.diaporama.lienhypertitle.banner')}</a></li>
            <li><a href="#qr-code-slide">{t('guides.diaporama.lienhypertitle.qrcodeslide')}</a></li>
            <li><a href="#chrome">{t('guides.diaporama.lienhypertitle.Chrome')}</a></li>
          </ul>

          <div><h4 id="start-diapo">{t('guides.diaporama.lienhypertitle.start')}</h4><p><Trans i18nKey="guides.diaporama.text.start" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p></div>
          <img src={BeOnWallStart} alt="Mur digital Start" className="guide-img" />

          <div><h4 id="font-style">{t('guides.diaporama.lienhypertitle.font')}</h4><p><Trans i18nKey="guides.diaporama.text.font" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p></div>
          <img src={BeOnWallSettings} alt="Mur digital Settings" className="guide-img-settings" />

          <div><h4 id="colors">{t('guides.diaporama.lienhypertitle.colors')}</h4><p><Trans i18nKey="guides.diaporama.text.colors" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p></div>
          <div><h4 id="background-image">{t('guides.diaporama.lienhypertitle.background')}</h4><p><Trans i18nKey="guides.diaporama.text.background" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p></div>
          <div><h4 id="banner">{t('guides.diaporama.lienhypertitle.banner')}</h4><p><Trans i18nKey="guides.diaporama.text.banner" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p></div>
          <div><h4 id="qr-code-slide">{t('guides.diaporama.lienhypertitle.qrcodeslide')}</h4><p><Trans i18nKey="guides.diaporama.text.qrcodeslide" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p></div>
          <div><h4 id="chrome">{t('guides.diaporama.lienhypertitle.Chrome')}</h4><p><Trans i18nKey="guides.diaporama.text.Chrome" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p></div>
        </div>
      )}


     {activeTab === 'media' && (
      <div className="event-info guide-info">
        <h3>{t('guides.title.Media')}</h3>
        <p>{t('guides.Media.title')}</p>
        <ul style={{ textAlign: 'left' }}>
          <li><a href="#select-elements">{t('guides.Media.lienhypertitle.selectmultielement')}</a></li>
          <li><a href="#delete-elements">{t('guides.Media.lienhypertitle.deleteelements')}</a></li>
          <li><a href="#confirm-delete">{t('guides.Media.lienhypertitle.downloadelements')}</a></li>
        </ul>

        <div><h4 id="select-elements">{t('guides.Media.lienhypertitle.selectmultielement')}</h4><p><Trans i18nKey="guides.Media.text.selectmultielement" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p></div>
        <div><h4 id="delete-elements">{t('guides.Media.lienhypertitle.deleteelements')}</h4><p><Trans i18nKey="guides.Media.text.deleteelements" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p></div>
        <img src={BeOnWallDownloaddeleteimages} alt="Téléchargement image & message et suppression" className="guide-img" />
        <div><h4 id="confirm-delete">{t('guides.Media.lienhypertitle.downloadelements')}</h4><p><Trans i18nKey="guides.Media.text.downloadelements" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p></div>
      </div>
    )}


       {activeTab === 'account' && (
        <div className="event-info guide-info">
          <h3>{t('guides.title.Abonnements')}</h3>
          <p>{t('guides.Compte.title')}</p>
          <ul style={{ textAlign: 'left' }}>
            <li><a href="#login">{t('guides.Compte.lienhypertitle.connexion')}</a></li>
            <li><a href="#update-email">{t('guides.Compte.lienhypertitle.modifieremail')}</a></li>
            <li><a href="#change-password">{t('guides.Compte.lienhypertitle.mdp')}</a></li>
            <li><a href="#subscription-level">{t('guides.Compte.lienhypertitle.abonnement')}</a></li>
          </ul>

          <div><h4 id="login">{t('guides.Compte.lienhypertitle.connexion')}</h4><p><Trans i18nKey="guides.Compte.text.connexion" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p></div>
          <div><h4 id="update-email">{t('guides.Compte.lienhypertitle.modifieremail')}</h4><p><Trans i18nKey="guides.Compte.text.modifieremail" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p></div>
          <img src={BeOnWallProfile} alt="Profil utilisateur" className="guide-img" />
          <div><h4 id="change-password">{t('guides.Compte.lienhypertitle.mdp')}</h4><p><Trans i18nKey="guides.Compte.text.mdp" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p></div>
          <div><h4 id="subscription-level">{t('guides.Compte.lienhypertitle.abonnement')}</h4><p><Trans i18nKey="guides.Compte.text.abonnement" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p></div>
        </div>
      )}


      {activeTab === 'security' && (
        <div className="event-info guide-info">
          <h3>{t('guides.title.Langue')}</h3>
          <p>{t('guides.Abonnements.title')}</p>
          <ul style={{ textAlign: 'left' }}>
            <li><a href="#event-blocked">{t('guides.Abonnements.lienhypertitle.Eventlimit')}</a></li>
            <li><a href="#check-subscription">{t('guides.Abonnements.lienhypertitle.checksubscription')}</a></li>
          </ul>

          <div><h4 id="event-blocked">{t('guides.Abonnements.lienhypertitle.Eventlimit')}</h4><p><Trans i18nKey="guides.Abonnements.text.Eventlimit" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p></div>
          <div><h4 id="check-subscription">{t('guides.Abonnements.lienhypertitle.checksubscription')}</h4><p><Trans i18nKey="guides.Abonnements.text.checksubscription" components={{ bold: <span className="bold-gold" />, br: <br /> }} /></p></div>
        </div>
      )}


      </div>
    </div>
  </>
  );
}

function Guide() {
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [activeTab, setActiveTab] = useState('Event');
  const { t } = useTranslation();
  const breadcrumbLabel = {
  Event: t('guides.tab.event'),
  diaporama: t('guides.tab.diaporama'),
  media: t('guides.tab.Media'),
  account: t('guides.tab.Compte'),
  security: t('guides.tab.Abonnements')
};

  

  return (
    <div className="event-detail-container guide-page">
      <div className="sidebar-toggle-button" onClick={() => setSidebarVisible(prev => !prev)}>
        {sidebarVisible ? <FaChevronLeft /> : <FaChevronRight />}
      </div>

      <div className={`sidebar ${sidebarVisible ? 'visible' : 'hidden'}`}>
        <div className="sidebar-section">
          <a href="#" onClick={() => setActiveTab('Event')} data-tooltip="Tutoriel accueil"><FaHome /> {t('guides.tab.event')}</a>
          <a href="#" onClick={() => setActiveTab('diaporama')} data-tooltip="Tutoriel diaporama"><FaPlay /> {t('guides.tab.diaporama')}</a>
          <a href="#" onClick={() => setActiveTab('media')} data-tooltip="Tutoriel médias"><FaImage /> {t('guides.tab.Media')}</a>
          <a href="#" onClick={() => setActiveTab('account')} data-tooltip="Tutoriel compte"><FaUser /> {t('guides.tab.Compte')}</a>
          <a href="#" onClick={() => setActiveTab('security')} data-tooltip="Tutoriel abonnements"><FaLock /> {t('guides.tab.Abonnements')}</a>
        </div>
      </div>

      
      <div className="content">
        <div style={{ marginLeft: '30px' }}>
          <Breadcrumbs
            items={[
              { label: '' },
              { href: '/guides', label: 'Guides' },
              {
                label: breadcrumbLabel[activeTab] || ''
              }
            ]}
            separator={<MdChevronRight style={{ color: '#facc15' }} />}
          />
        </div>

        <GuideContent activeTab={activeTab} />
      </div>
    </div>
  );
}


export default Guide;
